// Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc.
// svgs/regular/chevron-right.svg: path and width byte-identical (components/icons, Phase 5).
export default function RegularChevronRightIcon({
  className,
}: {
  className?: string
}) {
  return (
    <svg
      aria-hidden="true"
      className={className}
      data-page-icon="regular/chevron-right"
      fill="currentColor"
      focusable="false"
      height="1em"
      overflow="visible"
      viewBox="0 0 320 512"
      width="0.625em"
    >
      <path d="M305 239c9.4 9.4 9.4 24.6 0 33.9L113 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L79 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L305 239z" />
    </svg>
  )
}
